import React, { createContext, useContext } from 'react'

const ScrollResizeCompensationContext = createContext(true)

export function ScrollResizeCompensationProvider({ compensate = true, children }) {
    return (
        <ScrollResizeCompensationContext.Provider value={compensate}>
            {children}
        </ScrollResizeCompensationContext.Provider>
    )
}

export function useScrollResizeCompensation() {
    return useContext(ScrollResizeCompensationContext)
}
